// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.


export const environment = {
  production: true,  
  api_url: "https://indvisa.org/api",
  api_url_Image: "https://eta.org.lk",
  CreatePayment: "/MakePaymentSrilanka/CreatePayment",
  ExecutePayment: "/MakePaymentSrilanka/ExecutePayment",
  InsertApplicationPaymentRazorpay:
    "/MakePaymentSrilanka/RazorPayPaymentInsert",
  saveInsertTouristIndividual: "/ApplicationSrilanka/InsertTouristIndividual",
  saveInsertBussinessIndividual:
    "/ApplicationSrilanka/InsertBussinessIndividual",
  getTouristIndividual: "/ApplicationSrilanka/GetTouristIndividual",
  getBusinessIndividual: "/ApplicationSrilanka/GetBusinessIndividual",
  getApplicationpaymentDetails:
    "/ApplicationSrilanka/getApplicationpaymentDetails",
  getApplicationSuccess: "/ApplicationSrilanka/GetApplicationSuccess",
  getSecreteData: "/Application/GetCredentials",
  Getfromno: "/ApplicationSrilanka/Getfromno",
  login_path: "/users/login",
  login_auth_path: "/users/user",
};



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/environments/environment.ts